<n-slide-window *ngIf="pageReady"
    [visible]="windowVisible"
    width="8rem"
    (onHide)="close()">
    <n-header>
        <h1>{{title}}</h1>
        <n-help-link [key]="policyData ? 'antivirusonaccesspolicyModify' : 'antivirusonaccesspolicyCreate'">
        </n-help-link>
    </n-header>
    <form [errorMessage]="errorMessage"
        [formGroup]="vm"
        class="common-form">
        <!-- 名称 -->
        <n-form-item [label]="i18n.name"
            [required]="true">
            <input nInput
                style="width: 3.94rem;"
                *ngIf="!policyData"
                id="create-on-access-policy-name"
                type="text"
                formControlName="name">
            <span *ngIf="policyData">{{policyData.name}}</span>
        </n-form-item>
        <!-- 不扫描时间段 -->
        <n-form-item [label]="i18n.excludePeriod">
            <n-checkbox id="create-on-access-policy-exclude-time-checkbox"
                style="width: .6rem;"
                [label]="i18n.restricted"
                formControlName="isNeedExcludePeriod"
                (onChange)="onExcludePeriodChange()">
            </n-checkbox>
            <div class="inline-flex-wrapper exclude-time" *ngIf="vm.value.isNeedExcludePeriod">
                <n-time id="create-on-access-policy-exclude-start-time"
                    style="width: 1.42rem;"
                    formControlName="excludeStartTime"
                    [showSeconds]="false">
                </n-time>
                <span>—</span>
                <n-time id="create-on-access-policy-exclude-end-time"
                    style="width: 1.42rem;"
                    formControlName="excludeEndTime"
                    [showSeconds]="false"
                    [support24_00]="true">
                </n-time>
                <button nButton
                    class="mb-3"
                    id="create-on-access-policy-exclude-time-add-btn"
                    type="button"
                    [label]="i18n.addBtn"
                    (click)="addExcludePeriod()">
                </button>
            </div>
            <n-tip *ngIf="excludePeriodErrTip && vm.value.isNeedExcludePeriod"
                type="failed"
                [content]="excludePeriodErrTip">
            </n-tip>
            <div class="period-list-body" *ngIf="vm.value.isNeedExcludePeriod">
                <n-multi-mes [options]="excludePeriodObjList"
                    (onRemoveItem)="removePeriod($event.msg)"
                    (onClearAll)="removePeriod()">
                </n-multi-mes>
            </div>
        </n-form-item>
        <!-- 不扫描文件类型 -->
        <n-form-item [label]="i18n.unscannedFileType">
            <n-multi-input id="create-on-access-policy-exclude-file-type"
                style="width: 3.94rem;"
                formControlName="excludeFileType"
                [nTooltip]="i18n.unscannedFileTypeTip"
                nTooltipTrigger="focus"
                nTooltipPlacement="left"
                [seperator]="fileTypeSeperator">
            </n-multi-input>
        </n-form-item>
        <!-- 不扫描文件路径 -->
        <n-form-item [label]="i18n.excludeFilePath">
            <n-multi-input id="create-on-access-policy-exclude-file-path"
                style="width: 3.94rem;"
                formControlName="excludeFilePath"
                [nTooltip]="i18n.excludeFilePathTip"
                nTooltipTrigger="focus"
                nTooltipPlacement="left"
                [seperator]="filePathSeperator">
            </n-multi-input>
        </n-form-item>
        <!-- 最大可扫描文件大小 -->
        <n-form-item [label]="i18n.maxScanFileSize">
            <div class="inline-flex-wrapper">
                <n-checkbox id="create-on-access-policy-max-scan-size-checkbox"
                    style="width: .6rem;"
                    [label]="i18n.restricted"
                    formControlName="restricted"
                    (onChange)="onStrategyChange()">
                </n-checkbox>
                <n-capacity *ngIf="vm.value.restricted"
                    id="create-on-access-policy-max-scan-size-capacity"
                    style="width: 3rem"
                    [units]="maxScanCapacityUnit"
                    [nonDecimalUnits]="maxScanCapacityUnit"
                    formControlName="restrictCapacity">
                </n-capacity>
            </div>
        </n-form-item>
        <!-- 超时时间 -->
        <n-form-item [label]="i18n.timeout">
            <div class="inline-flex-wrapper">
                <n-spinner id="create-on-access-policy-timeout"
                    [onlyInput]="true"
                    [min]="5"
                    [max]="35"
                    formControlName="timeout"
                    [rangeTip]="true">
                </n-spinner>
            </div>
        </n-form-item>
        <!-- 超时后是否可访问 -->
        <n-form-item [label]="i18n.accessAfterTimeout">
            <n-checkbox id="create-on-access-policy-access-after-timeout-checkbox"
                style="width: .6rem;"
                [label]="i18n.yesLabel"
                formControlName="accessAfterTimeout">
            </n-checkbox>
        </n-form-item>
        <!-- 触发时机 -->
        <n-form-item [label]="i18n.scanTrigger">
            <n-select id="create-on-access-policy-access-scan-trigger"
                [options]="scanTriggerList"
                formControlName="scanTrigger">
            </n-select>
        </n-form-item>
    </form>

    <n-footer>
        <button id="create-on-access-scan-ok-btn"
            nButton
            theme="primary"
            [label]="i18n.okBtn"
            (click)="onOk()">
        </button>
        <button id="create-on-access-scan-cancel-btn"
            nButton
            [label]="i18n.cancelBtn"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>